import React from 'react'
import './samplequote.css';
import SampleProduct from '../sampleproduct/sampleproduct';

function Samplequote() {
  return (
    <div style={{marginTop:'-10rem'}}>
      <SampleProduct/>
    </div>
  )
}

export default Samplequote
